import React from 'react';
import FormControl from "@mui/material/FormControl";
import FormLabel from "@mui/material/FormLabel";
import {useSxStyles as classes} from "../styles/sxStyles";
import Select from "@mui/material/Select";

const PaymentLocation = (props) => {
    const locations = props.locations;
    const user = props.user;
    const setLocation = props.setLocation;
    const offset = props.offset;

    return (<>
        <FormControl
            name='location'
            fullWidth
            sx={[offset ? {
                marginLeft: '.5rem'
            } : {
                marginLeft: '0'
            }]}
        >
            <FormLabel shrink={true} sx={classes.inputLabel}>Location</FormLabel>
            <Select
                name='location'
                fullWidth
                sx={{height: '2rem'}}
                variant='outlined'
                native
                inputProps={{
                    defaultValue: (user && user.location ? user.location : 'Virtual Terminal')
                }}
                onChange={(e) => setLocation(e.target.value)}
            >
                <option key="-1" value=''>None Selected</option>
                { locations.map(loc => {
                    return (
                        <option key={loc.name} value={loc.name}>{loc.displayName}</option>
                    );
                })}
            </Select>
        </FormControl>
    </>);
}

export default PaymentLocation;
